import { Component } from '@angular/core';
import { ViewersComponent } from './viewer/viewers.component';
import { OverlayBtnsComponent } from './overlay-btns/overlay-btns.component';

@Component({
  selector: 'app-viewport',
  imports: [ViewersComponent, OverlayBtnsComponent ],
  templateUrl: './viewport.component.html',
  styleUrl: './viewport.component.css'
})
export class ViewportComponent {

}
